import { getDeviceByControl, getLightColors } from './Device';
import { dataSource } from '../../Functions';
import { ControlConfig, HardwareConfigRecord } from '../documents/HardwareConfig';
import { AlertRecord } from '../../alert';
import { DesiredStateConfig, DesiredStateItem } from '../documents/DesiredState';

export const getLightControlColors = function(control:ControlConfig, config:HardwareConfigRecord) {
    config = config || dataSource.getCurrentConfig() as HardwareConfigRecord;
    const device = getDeviceByControl(control.UUID, config);
    if (!device) {
        return false;
    }
    return device ? getLightColors(device) : false;
}

export const isControlClaimedByFp = function (desiredState: DesiredStateItem) {
    return (desiredState?.DisabledReasons || []).includes('FREEZE_PROTECT');
}

/** Calculates bagde to place on the Control power button */
export const getControlBadge = function(
    control: ControlConfig,
    alerts: AlertRecord[],
    desiredState: DesiredStateItem,
    colors: { orange: string, blue: string }
): {
    icon: string, color?: string, followsPower?: boolean
} | undefined {
    let badge = undefined;

    if (alerts
        ?.filter(item => item.controlUuids?.includes(control.UUID))
        ?.length
    ) {
        return {
            icon: 'exclamation',
            color: colors.orange,
        };
    } else if (isControlClaimedByFp(desiredState) ) {
        return {
            icon: 'snowflake',
            color: colors.blue,
        };
    } else if (desiredState.Status?.toUpperCase && desiredState.Status.toUpperCase() === 'ON' && desiredState.OnUntil) {
        return {
            icon: 'clock',
            color: colors.orange,
            followsPower: true,
        };
    } else if (desiredState.InconsistentCombinedControl === true) {
        return {
            icon: 'exclamation',
            followsPower: true,
        };
    }

    return badge;
}
